export default __webpack_public_path__ + "static/media/home_03_active.bac95f77.png";